const INPUT_BASE =
  'block w-full rounded-md border bg-surface px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 disabled:bg-surface-2 disabled:text-fg-muted';
const INPUT_OK = 'border-line-strong/20 focus:border-accent focus:ring-line/15';
const INPUT_INVALID = 'border-danger ring-1 ring-danger/40 focus:border-danger focus:ring-danger/30';

/**
 * Input class with optional invalid (red) state. `topMargin` keeps the default
 * `mt-1.5` for standalone inputs; pass false for inline sub-inputs (address,
 * name) that the parent already spaces.
 */
export function inputClass(invalid = false, topMargin = true): string {
  return [topMargin ? 'mt-1.5' : '', INPUT_BASE, invalid ? INPUT_INVALID : INPUT_OK]
    .filter(Boolean)
    .join(' ');
}

export const LABEL_CLASS = 'block text-sm';
export const LABEL_TEXT_CLASS = 'font-medium text-fg-muted';
export const HELP_CLASS = 'mt-1 block text-xs text-fg-dim';
